import { z } from 'zod';
export var DownloadObjectRecursive;
(function (DownloadObjectRecursive) {
    DownloadObjectRecursive.paramsSchema = z.object({
        workspaceId: z.coerce.number(),
        objectId: z.coerce.number(),
    });
    DownloadObjectRecursive.bodySchema = z.object({
        objectIds: z.number().array().optional(),
    });
    DownloadObjectRecursive.responseSchema = z.object({
        websocketKey: z.string(),
    });
})(DownloadObjectRecursive || (DownloadObjectRecursive = {}));
